import {
    INTEGRATIONS_DELETE_CEREBRUMX_OPEN_MODAL,
    INTEGRATIONS_DELETE_CEREBRUMX_REQUEST,
    INTEGRATIONS_DELETE_CEREBRUMX_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    companyIntegrationId: null,
    fleetId: null,
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case INTEGRATIONS_DELETE_CEREBRUMX_OPEN_MODAL:
            return { ...state, openModal: true, fleetId: action.payload.fleetId, companyIntegrationId: action.payload.companyIntegrationId }

        case INTEGRATIONS_DELETE_CEREBRUMX_REQUEST:
            return { ...state, loading: true }

        case INTEGRATIONS_DELETE_CEREBRUMX_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DELETE_CEREBRUMX_INTEGRATION"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};